import { Kymw68TagComboBoxComponent } from './tag-combo-box.component';
import { Tag } from './tag.model';

/**
 * タグコンボボックスモデル
 *
 * @export TagComboBoxModel
 * @class TagComboBoxModel
 */
export class TagComboBoxModel {

  /**
   * タグリスト
   */
  public tagList: Tag[];
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // コンボボックスインスタンス
  public component: Kymw68TagComboBoxComponent;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // 初期設定コード値
  public setTagValue: string;
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  // 初期設定インデックス
  public selectedIndex: number = <number>-1;


  /**
   * タグIDを更新する
   *
   * @param {*} tagList タグIDのサーバ取得データ
   * @memberof TagComboBoxModel
   */
  public updateTagList(tagList: any[]): void {
    let tempDataList: Tag[] = [];

    if (tagList !== null) {
      tempDataList = tagList;
    }

    // 処理件数
    let index: number = <number>0;

    // コード+：+名称追加
    tempDataList.forEach(item => item.TagIdName = item.TagId + ':' + item.TagName);

    // 先頭空白追加
    if (this.blank) {
      const ob = new Tag();
      tempDataList.splice(index, 0, ob);
      index = <number>1;
    }

    // テンプから表示用に設定する
    this.tagList = tempDataList;
    // リスト生成完了フラグセット
    this.completeUpdateFlg = true;

    // 画面側で設定する
    this.component.updateSelectedTagId();
    this.component.updateSelectedIndex();
  }

}
